const FEATURES = [
  {
    icon: 'ri-search-eye-line',
    title: '全文快速检索',
    desc: '支持按片名、简介、导演与主演进行关键词搜索，一步直达目标影片。',
  },
  {
    icon: 'ri-equalizer-line',
    title: '多维分类筛选',
    desc: '类型、年份、地区多维组合筛选，配合最新、热门、评分多种排序方式。',
  },
  {
    icon: 'ri-magic-line',
    title: '智能关联推荐',
    desc: '根据影视类型、导演与地区自动推荐相关作品，发现更多好内容。',
  },
  {
    icon: 'ri-device-line',
    title: '多端流畅浏览',
    desc: 'PC 与手机端自适应布局，筛选面板可折叠，随时随地轻松查阅。',
  },
];

const STATS = [
  { value: '22+', label: '演示影视条目' },
  { value: '7', label: '覆盖国家与地区' },
  { value: '10+', label: '细分类型标签' },
  { value: '6', label: '智能推荐维度' },
];

export default function SiteIntro() {
  return (
    <section className="bg-primary-950 py-14 text-background-200 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-[0.3em] text-accent-400">
            ABOUT STAR CINEMA
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            星辰影院，一站式影视浏览与资讯平台
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-300 md:text-base">
            我们聚合最新电影与热门电视剧资源信息，提供清晰的分类、便捷的搜索与精准的推荐，
            帮助你用最短的时间找到值得一看的作品。所有内容均为演示示例，专注于浏览与导航体验。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {FEATURES.map((feature) => (
            <div
              key={feature.title}
              className="rounded-xl border border-primary-800/70 bg-primary-900/60 p-5 transition-colors hover:border-accent-500/60"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className={`${feature.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 text-base font-semibold text-background-50">{feature.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-300">{feature.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-2 gap-6 border-t border-primary-800/70 pt-8 lg:grid-cols-4">
          {STATS.map((stat) => (
            <div key={stat.label}>
              <p className="font-heading text-2xl font-extrabold text-accent-400 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-1 text-xs text-background-400 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}